const activeEvents = {
  bindings: {
    settings: '<',
    area: '<',
    gridlet: '<',
  },
  templateUrl: '/modules/gridlets/active-events/active-events.html',
  controller: 'ActiveEventsController',
};

angular
  .module('gridlets.module')
  .component('activeEvents', activeEvents);